<template>
  <picture>
    <source
      v-for="s in sizes"
      :key="s.index"
      :media="`(max-width:${s.break}px)`"
      :srcSet="s.url" />
    <img
      data-object-fit="cover"
      :data-src="defaultImg"
      :src="defaultImg"
      :alt="description"
      :class="cssClass || 'block w-full'" />
  </picture>
</template>

<script>
export default {
  props: [
    'sizes',
    'defaultImg',
    'description',
    'cssClass'
  ]
}
</script>